import { defineComponent as _defineComponent } from 'vue'
import device from '@@/bits/device'
import { postColorTailwindClass } from '@@/bits/post_color'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzPlainButton, { OzPlainButtonColorScheme } from '@@/library/v4/components/OzPlainButton.vue'
import { createDomElement } from '@@/native_bridge/ui'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import type { Post, PostColor } from '@@/types'
import emitClickOnTouch from '@@/vuedirectives/emit_click_on_touch'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostMoreActions',
  props: {
    post: null,
    backgroundColor: null,
    colorScheme: null,
    xOverlay: { type: Boolean, default: true },
    xFillerElements: { type: Boolean, default: true }
  },
  emits: ["dropdown", "edit"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'dropdown', rect: DOMRect): void
  (name: 'edit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { post: Post, backgroundColor: PostColor, colorScheme: 'light' | 'dark', xOverlay: boolean, xFillerElements: boolean };

const vEmitClickOnTouch = emitClickOnTouch
const isTouchable = device.touchable





const { isStream, isScreenshotMode, user, isFrozen } = storeToRefs(useSurfaceStore())
const { canIEdit, canIWrite } = storeToRefs(useSurfacePermissionsStore())

const isEditButtonFocused = ref<boolean>(false)
const isMoreActionsButtonFocused = ref<boolean>(false)

const isPostAuthor = computed<boolean>(() => {
  return props.post.author_id === user.value?.id
})

const xEditPost = computed<boolean>(() => {
  if (isFrozen.value || isTouchable) return false
  return canIEdit.value || (canIWrite.value && isPostAuthor.value)
})

const isLightColorScheme = computed<boolean>(() => {
  return props.colorScheme === 'light'
})

const bgColorClass = computed<string>(() => {
  return postColorTailwindClass({ postColor: props.backgroundColor, isLightColorScheme: isLightColorScheme.value })
})

const cornerColorClass = computed<string>(() => {
  switch (props.backgroundColor) {
    case 'red':
      return isLightColorScheme.value ? 'corner-scarlet-100' : 'corner-scarlet-900'
    case 'orange':
      return isLightColorScheme.value ? 'corner-canary-100' : 'corner-tangerine-900'
    case 'green':
      return isLightColorScheme.value ? 'corner-park-100' : 'corner-park-900'
    case 'blue':
      return isLightColorScheme.value ? 'corner-oceanic-100' : 'corner-oceanic-900'
    case 'purple':
      return isLightColorScheme.value ? 'corner-grape-100' : 'corner-grape-900'
    default:
      return isLightColorScheme.value ? 'corner-light-ui-100' : 'corner-dark-ui-100'
  }
})

function onMoreActionsButtonClick(event: Event): void {
  const button = event.currentTarget as HTMLButtonElement

  const buttonRect = createDomElement(button)
  const buttonContentRect = createDomElement(button.firstElementChild as HTMLElement)

  const buttonContentCenter = {
    x: buttonContentRect.x + buttonContentRect.width / 2,
    y: buttonContentRect.y + buttonContentRect.height / 2,
  }

  const topOffset = buttonContentCenter.y - buttonRect.y

  // The trigger rect will be calculated based on the following assumptions:
  // 1. The button content (i.e. the icon) is the visual center of the button
  // 2. The top offset of the button determines the offset from the center of
  //    the visual layout of the button
  // Thus to calculate the right trigger rect we have to:
  // 1. Find the center of the button content
  // 2. Find its offset from the top of the button
  // 3. Extend outwards from the center of the button content in all
  //    directions to obtain the trigger rect

  const minX = buttonContentCenter.x - topOffset
  const minY = buttonRect.y
  const maxX = buttonContentCenter.x + topOffset
  const maxY = buttonContentCenter.y + topOffset
  const triggerRect = new DOMRect(/* x */ minX, /* y */ minY, /* width */ maxX - minX, /* height */ maxY - minY)

  emit('dropdown', triggerRect)
}

return { __sfc: true,vEmitClickOnTouch, isTouchable, props, emit, isStream, isScreenshotMode, user, isFrozen, canIEdit, canIWrite, isEditButtonFocused, isMoreActionsButtonFocused, isPostAuthor, xEditPost, isLightColorScheme, bgColorClass, cornerColorClass, onMoreActionsButtonClick, OzIcon, OzPlainButton, OzPlainButtonColorScheme }
}

})